<template>
  <modal
    ref="collectionPointCreateModal"
    :title="title()"
    template="question"
    ref-name="collectionPointCreateModal"
    :first-button-text="firstButtonText()"
    :icon-enabled="false"
    :second-button-text="secondButtonText()"
    :close-button-enabled="false"
    :first-button-disabled="false"
    :hide-first-button="isCreateOrder && collectionPointCreateSuccess"
    :second-button-disabled="disableSecoundButton()"
    class="collection-point-modal"
    @first-cta="closeModal()"
    @second-cta="handleSecondButton()"
  >
    <template v-if="!collectionPointCreateSuccess">
      <div
        v-if="collectionPointCreateError"
        class="feedback-error"
      >
        <span>Não foi possível criar o posto de coleta. Este posto de coleta já está registrado.</span>
      </div>
      <div
        v-if="edit"
        class="feedback-error"
      >
        <span>A edição do Posto de Coleta não será aplicada às Ordens de Serviço já transferidas</span>
      </div>
      <div class="textarea-wrapper">
        <textarea 
          id="collectionPoint-name"
          v-model="name"
          name="collectionPoint-name"
          placeholder="Insira o nome do posto de coleta"
          maxlength="100"
          rows="3"
          required
          @input="name = $event.target.value.toUpperCase()"
        />
        <span class="counter">{{ name ? name.length + '/100': '' }}</span>
      </div>
    </template>
    <template v-else>
      <div class="success-feedback">
        <img
          src="/static/images/success-green.svg"
          alt="icone-sucesso"
        >
        <p class="feedback-title">
          Posto de coleta criado com <br>sucesso!
        </p>
        <div class="hr">
          <p v-if="isCreateOrder">
            Agora é só retomar seu <br>cadastro de OS:
          </p>
          <p v-else>
            Deseja adicionar outro posto?
          </p>
        </div>
      </div>
    </template>
  </modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CollectionPointCreateModal',
  data: () => ({
    name: '',
    id: null,
    edit: false,
    success: false
  }),
  methods: {
    ...mapActions(['collectionPointCreate']),
    ...mapActions(['collectionPointEdit']),
    ...mapActions(['setcollectionPointStatus']),
    title () {
      if (this.edit) return 'Editar posto de coleta'
      return this.success ? '' : 'Novo posto de coleta'
    },
    firstButtonText () {
      return this.success ? 'VOLTAR' : 'CANCELAR'
    },
    secondButtonText () {
      if (this.isCreateOrder && this.success) return 'OK'
      if (this.edit) return 'SALVAR'
      return this.success ? 'NOVO POSTO' : 'ADICIONAR'
    },
    closeModal () {
      this.setcollectionPointStatus('STATUS_INITIAL')
      this.$refs.collectionPointCreateModal.close()
      this.name = ''
    },
    handleSecondButton () {
      if (this.edit) {
        this.collectionPointEdit({
          idCollectionPoint: this.id.toString(),
          name: this.name
        })
        this.closeModal()
      } else {
        if (this.isCreateOrder && this.success) {
          this.closeModal()
          this.setcollectionPointStatus('STATUS_INITIAL')
        } else if (this.success) {
          this.name = ''
          this.setcollectionPointStatus('STATUS_INITIAL')
        } else {
          this.collectionPointCreate(this.name)
          this.$emit('collectPostCreated', this.name)
        }
      }
      this.edit = false
    },
    openModal (collectionPoint) {
      if (collectionPoint) {
        this.name = collectionPoint.collecPointName || collectionPoint.name
        if (!this.isCreateOrder && !this.isEditingOrder) {
          this.edit = true
          this.id = collectionPoint.idCollectionPoint
        }
      }
      this.$refs.collectionPointCreateModal.open()
    },
    disableSecoundButton () {
      if (this.isCreateOrder && this.success) {
        return false
      }
      return this.name.length < 3
    }
  },
  computed: {
    ...mapGetters(['isEditingOrder']),
    ...mapGetters(['collectionPointCreateSuccess']),
    ...mapGetters(['collectionPointCreateError']),
    isCreateOrder () {
      return this.$route ? this.$route.name === 'Cadastrar Ordem de Serviço' : false
    }
  },
  watch: {
    collectionPointCreateSuccess (val) {
      this.success = val
    },
    name () {
      let nameNormalized = this.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      nameNormalized = nameNormalized.replace(/[^\w\s]/gi, '')
      nameNormalized = nameNormalized.toUpperCase()
      nameNormalized = nameNormalized.trimStart()
      nameNormalized = nameNormalized.replace(/\s+/g, ' ')
      this.name = nameNormalized
    }
  }
}
</script>

<style lang="scss">
.collection-point-modal{
  .feedback-error {
      margin-top: 10px;
      background-color: #fdedd3;
      border-radius: 5px;
      padding: 10px 10px 10px 40px;
      text-align: left;
      background-image: url('/static/images/alert-icon.svg');
      background-repeat: no-repeat;
      background-position: 12px 12px;
      margin-bottom: 15px;
    span {
      color: #4A4A4A;
      letter-spacing: 0;
      max-width: 350px;
      display: block;
    }
  }
  .textarea-wrapper {
    padding: 15px 20px 35px;
    border-radius: 5px;
    background-color: #f5f5f5;
    textarea {
      width: 100%;
      border-color: #aeaeae;
      resize: none;
      border-radius: 5px;
      padding: 7px 10px;
      font-family: 'Roboto';
      font-size: 14px;
      min-height: 85px;
      color: #4A4A4A;
      &:focus {
        outline: none;
        border-color: #979797;
      }
      &::placeholder {
        color: #7A7A7A;
      }
    }
    span {
      color: #7a7a7a;
      float: right;
      letter-spacing: 0;
      font-size: 14px;
    }
  }
  .success-feedback {
    text-align: center;
    color: #617173;
    img {
      margin-bottom: 20px;
    }
    .feedback-title {
      font-family: 'Roboto';
      font-weight: normal;
      text-align: center;
      font-size: 22px;
    }
    .hr {
      border-top: 1px solid #b8b7bf;
      padding-top: 20px;
      max-width: 270px;
      margin: 0 auto;
      margin-top: 20px;
      p {
        font-size: 16px;
        text-align: center;
      }
    }
  }
}
</style>
